<template>
  <div class="login-new">
    <div class="login-container">
      <!-- 登录表单 -->
      <div class="login-form-container">
        <div class="login-form">
          <h2 class="login-title">Log In</h2>

          <!-- 提示信息 -->
          <div class="notice-box">
            <div class="notice-content">
              <div class="notice-icon">
                <div class="icon-circle">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path
                        d="M7 0C3.134 0 0 3.134 0 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 10.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75.75.336.75.75-.336.75-.75.75zm.75-3c0 .414-.336.75-.75.75s-.75-.336-.75-.75V4.5c0-.414.336-.75.75-.75s.75.336.75.75v3z"
                        fill="#005EB8"/>
                  </svg>
                </div>
              </div>
              <p class="notice-text">
                When logging in with an 11-digit phone number from a non-Chinese region, please complete the national
                area code, e.g. 00852.
              </p>
            </div>
          </div>

          <!-- 输入框区域 -->
          <div class="input-section">
            <!-- 邮箱/手机/ID输入框 -->
            <div class="input-group">
              <div class="input-wrapper">
                <div class="input-icon">
                  <img src="@/assets/login/ic_user.png" height="16" width="16"/>
                </div>
                <div class="input-divider"></div>
                <input
                    type="text"
                    placeholder="E-mail/ Mobile/ lD/ Membership Number"
                    v-model="emailValue"
                    class="form-input"
                />
                <div class="input-success-icon" v-if="emailValue">
                  <img src="@/assets/login/ic_account_success.png" height="16" width="16"/>
                </div>
              </div>
            </div>

            <!-- 密码输入框 -->
            <div class="input-group">
              <div class="input-wrapper">
                <div class="input-icon">
                  <img src="@/assets/login/ic_password.png" height="16" width="16"/>
                </div>
                <div class="input-divider"></div>
                <input
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="Password"
                    v-model="passwordValue"
                    class="form-input"
                />
                <div class="input-success-icon" v-if="passwordValue">
                  <img src="@/assets/login/ic_account_success.png" height="16" width="16"/>
                </div>
              </div>
            </div>

            <!-- 验证码输入框 -->
            <div class="input-group">
              <div class="input-wrapper">
                <div class="input-icon">
                  <img src="@/assets/login/ic_verification.png" height="16" width="16"/>
                </div>
                <div class="input-divider"></div>
                <input
                    type="text"
                    placeholder="Verification code"
                    v-model="verificationValue"
                    class="form-input"
                />
                <div class="verification-code">
                  <span class="code-text">A7B9</span>
                </div>
              </div>
            </div>

            <!-- 忘记密码链接 -->
            <div class="forgot-password">
              <a href="javascript:;" @click="forgotPassword">Forgot Password？</a>
            </div>
          </div>

          <!-- 隐私政策同意 -->
          <div class="privacy-section">
            <div class="checkbox-wrapper">
              <a-checkbox v-model="privacyAgreed">
              </a-checkbox>
              <span @click="privacyAgreed = !privacyAgreed">I have read and agreed <span style="color: #D8000F;" @click.stop="goPrivacyPolicy">SICHUAN AIRLINES Privacy Policy</span></span>
            </div>
          </div>

          <!-- 登录按钮 -->
          <div class="login-button-section">
            <button
                class="login-button"
                :class="{ 'disabled': !canLogin }"
                @click="handleLogin"
                :disabled="!canLogin"
            >
              Log In
            </button>
          </div>
          
          <!-- 隐私协议提示弹窗 -->
          <CommonDialog
            :visible="showPrivacyDialog"
            :type="dialogConfig.type"
            :title="dialogConfig.title"
            :message="dialogConfig.message"
            :confirm-text="dialogConfig.confirmText"
            :cancel-text="dialogConfig.cancelText"
            @close="showPrivacyDialog = false"
            @cancel="showPrivacyDialog = false"
            @confirm="handleCommonDialogConfirm"
          />

          <!-- 注册链接 -->
          <div class="register-section">
            Register as an Golden Panda member
            <img src="@/assets/login/ic_goto.png" height="16px" width="16px"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonDialog from '@/components/common/CommonDialog.vue';

export default {
  components: {
    CommonDialog
  },
  name: "LoginNew",
  data() {
    return {
      emailValue: '',
      passwordValue: '',
      verificationValue: '',
      showPassword: false,
      privacyAgreed: false,
      showPrivacyDialog: false,
      dialogConfig: {
        type: 'error',
        title: 'Notification',
        message: 'Please read and agree to the SICHUAN AIRLINES Privacy Policy before proceeding with the login.',
        confirmText: 'Agree and Login',
        cancelText: 'Cancel'
      }
    };
  },
  computed: {
    canLogin() {
      return this.emailValue.trim() !== '' && 
             this.passwordValue.trim() !== '' && 
             this.verificationValue.trim() !== '';
    }
  },
  methods: {
    handleLogin() {
      if (!this.canLogin) {
        return;
      }

      // 检查是否同意隐私协议
      if (!this.privacyAgreed) {
        this.showPrivacyDialogModal();
        return;
      }

      console.log('登录信息:', {
        email: this.emailValue,
        password: this.passwordValue,
        verification: this.verificationValue
      });

      // 这里添加登录逻辑
      this.$router.push('/dashboard');
    },
    handleCommonDialogConfirm() {
      this.privacyAgreed = true;
      this.showPrivacyDialog = false;
      // 继续登录流程
      this.handleLogin();
    },
    // 动态设置弹窗配置
    setDialogConfig(config) {
      this.dialogConfig = {
        ...this.dialogConfig,
        ...config
      };
    },
    // 显示隐私协议弹窗
    showPrivacyDialogModal() {
      this.setDialogConfig({
        type: 'error',
        title: 'Notification',
        message: 'Please read and agree to the SICHUAN AIRLINES Privacy Policy before proceeding with the login.',
        confirmText: 'Agree and Login',
        cancelText: ''
      });
      this.showPrivacyDialog = true;
    },
    forgotPassword() {
      console.log('忘记密码');
      // 这里添加忘记密码逻辑
      this.$router.push('/forgot-password');
    },
    goRegister() {
      console.log('跳转注册');
      this.$router.push('/register');
    },
    goPrivacyPolicy() {
      console.log('跳转隐私政策');
      alert('SICHUAN AIRLINES Privacy Policy')
    }
  }
};
</script>

<style lang="less" scoped>
.login-new {
  position: relative;
  background: url('../../assets/login/icon_content_login_bg_new.png') no-repeat top right;;
  background-size: cover;
  display: flex;
  justify-content: center;


  .login-container {
    width: 1120px;
    min-width: 1120px;
    height: 670px;


    .login-form-container {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 60px 0;

      .login-form {
        width: 430px;
        //height: 550px;
        background: #FFFFFF;
        border: 1px solid #ECEEF0;
        border-radius: 8px;
        box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.04);
        padding: 24px 32px;

        .login-title {
          font-family: PingFang SC;
          font-weight: 600;
          font-size: 24px;
          line-height: 1.33;
          color: #333333;
          margin: 0 0 24px 0;
        }

        .notice-box {
          margin-bottom: 24px;

          .notice-content {
            display: flex;
            gap: 4px;
            padding: 8px;
            border: 1.5px solid #005EB8;
            border-radius: 4px;
            box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.25);

            .notice-icon {
              flex-shrink: 0;
              width: 16px;
              height: 20px;
              display: flex;
              align-items: center;
              justify-content: center;

              .icon-circle {
                width: 14px;
                height: 14px;
                background: #FFFFFF;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }

            .notice-text {
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 12px;
              line-height: 1.67;
              color: #616161;
              margin: 0;
              flex: 1;
            }
          }
        }

        .input-section {
          margin-bottom: 24px;

          .input-group {
            margin-bottom: 24px;

            .input-wrapper {
              display: flex;
              align-items: center;
              gap: 8px;
              padding: 6px;
              background: #F8F8F8;
              border: 1px solid #BCBCBC;
              border-radius: 4px;
              height: 48px;

              .input-icon {
                width: 16px;
                height: 16px;
                flex-shrink: 0;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              .input-divider {
                width: 1px;
                height: 12px;
                background: #BCBCBC;
                flex-shrink: 0;
              }

              .form-input {
                flex: 1;
                border: none;
                background: transparent;
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 14px;
                line-height: 1.57;
                color: #333333;
                outline: none;
                height: 22px;
              }
              
              .form-input::placeholder {
                color: #3F3F3F !important;
              }
              
              .form-input::-webkit-input-placeholder {
                color: #3F3F3F !important;
              }
              
              .form-input::-moz-placeholder {
                color: #3F3F3F !important;
              }
              
              .form-input:-ms-input-placeholder {
                color: #3F3F3F !important;
              }
              
              .input-success-icon {
                width: 16px;
                height: 16px;
                flex-shrink: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 8px;
              }

              .verification-code {
                width: 60px;
                height: 22px;
                background: #FFFFFF;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                border: 1px solid #D9D9D9;
                cursor: pointer;

                .code-text {
                  font-family: 'Courier New', monospace;
                  font-size: 12px;
                  font-weight: bold;
                  color: #333333;
                  letter-spacing: 1px;
                }
              }
            }
          }

          .forgot-password {
            text-align: right;
            margin-top: -8px;

            a {
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 14px;
              line-height: 1.4;
              color: #3F3F3F;
              text-decoration: none;

              &:hover {
                text-decoration: underline;
              }
            }
          }
        }

        .privacy-section {
          margin-bottom: 12px;

          .checkbox-wrapper {
            display: flex;
            align-items: center;
            gap: 4px;
            font-size: 12px;

            span {
              padding-left: 0;
              font-size: 12px;
              cursor: pointer;
            }
          }
        }

        .login-button-section {
          margin-bottom: 12px;

          .login-button {
            width: 100%;
            height: 48px;
            background: #D8000F;
            border: none;
            border-radius: 6px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 18px;
            line-height: 1.11;
            color: #FFFFFF;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover:not(.disabled) {
              background: #D8000F;
            }

            &.disabled {
              background: #FFC5C4;
              cursor: not-allowed;
              opacity: 0.6;
            }
          }
        }

        .register-section {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 16px;
          line-height: 1.5;
          color: #BB904A;
          text-decoration: none;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 4px;
        }
      }
    }
  }
}
</style>
